export default Object.freeze({
	facebook: 'https://www.facebook.com/daredrops',
	twitter: 'https://twitter.com/daredrops',
	discord: 'https://discord.gg/xmECwRu',
	instagram: 'https://www.instagram.com/dare.drops/',
	youtube: 'https://www.youtube.com/channel/UC9HaIflzLYyMTWaoMyok3VQ',
	twitch: 'https://www.twitch.tv/dare_drop',
	tiktok: 'https://www.tiktok.com/@daredrops',
})
